import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { AutoComplete, Form, Input, message, Select, TreeSelect } from 'antd';
import './style.css';
import { Device } from '../../../../types/Device';
import { getEditDevice } from '../../../../api/devices/getEditDevice';
import { useAuthStore } from '../../../../store/auth/auth';
import ButtonDeviceSave from '../../../buttons/buttonDeviceEdit/ButtonDeviceSave';
import ButtonDeviceAddToLayout from '../../../buttons/buttonDeviceEdit/ButtonDeviceAddToLayout';
import ButtonDeviceDelete from '../../../buttons/buttonDeviceEdit/ButtonDeviceDelete';
import { useGroupsStore } from '../../../../store/groups/Groups';
import { Group } from '../../../../types/Group';
import DeleteDeviceOneModal from '../../../modals/deleteDevice/DeleteDeviceOne';
import { useIsFormChanged } from '../../../../store/devices/getDeviceChange';
import NotSavedChanges from '../../../modals/notSavedChanges/NotSavedChanges';
import { useOwnerStore } from '../../../../store/owner/useOwnerStore';
import { Owner } from '../../../../types/Owner';
import { Option } from 'antd/lib/mentions';
import { useSelectedDevice } from '../../../../store/devices/SelectedDevice';
import AddDeviceInLayoutModal from './modals/AddDeviceInLayoutModal';

interface DescriptionsProps {
    device: Device | null;
}
const Description: React.FC<DescriptionsProps> = ({ device }) => {
    const [formLeft] = Form.useForm();
    const [formRight] = Form.useForm();
    const { user, SmartDVRToken } = useAuthStore();
    const [messageApi, contextHolder] = message.useMessage();
    const { groups, fetchGroups } = useGroupsStore();
    const { owners, fetchOwners } = useOwnerStore();
    const [selectedGroup, setSelectedGroup] = useState<Group | null>(null);
    const [selectedOwner, setSelectedOwner] = useState<Owner | null>(null);
    const [isDeleteDeviceOneModal, setIsDeleteDeviceOneModal] = useState(false);
    const { selectedDevice, setSelectedDevice } = useSelectedDevice();

    const { setIsFormChanged, setIsNotSavedModalVisible, isNotSavedModalVisible } =
        useIsFormChanged();
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(15);
    const [isAddToLayoutModalVisible, setIsAddToLayoutModalVisible] = useState(false);

    const handleDeviceAddToLayout = () => {
        if (!device) {
            messageApi.error('Устройство не выбрано');
            return;
        }
        setIsAddToLayoutModalVisible(true);
    };
    // Функция для поиска группы в дереве
    // const findGroupById = (groups: Group[], uid: string): Group | null => {
    //     for (const group of groups) {
    //         if (group.uid === uid) return group;
    //         if (group.sub_groups) {
    //             const found = findGroupById(group.sub_groups, uid);
    //             if (found) return found;
    //         }
    //     }
    //     return null;
    // };

    const getAllSubGroups = (group: Group): Group[] => {
        const subGroups: Group[] = [];
        group.sub_groups.forEach((subGroup) => {
            subGroups.push(subGroup);
            if (subGroup.sub_groups) {
                subGroups.push(...getAllSubGroups(subGroup));
            }
        });
        return subGroups;
    };

    const allGroups = useMemo(() => {
        const result: Group[] = [];
        groups.forEach((group) => {
            result.push(group);
            if (group.sub_groups) {
                result.push(...getAllSubGroups(group));
            }
        });
        return result;
    }, [groups]);

    const convertGroupsToTreeData = useCallback((groups: Group[]): any[] => {
        return groups
            .filter((group) =>
                group.uid !== '00000000-0000-0000-0000-000000000002' &&
                group.uid !== '00000000-0000-0000-0000-000000000003' &&
                group.name !== 'Несортированные'
            )
            .map((group) => ({
                title: group.name,
                value: group.name,
                key: group.uid,
                children: group.sub_groups ? convertGroupsToTreeData(group.sub_groups) : undefined,
            }));
    }, []);

    const treeData = useMemo(() => {
        const rootGroup = groups.find(group => group.name === 'Root');
        if (rootGroup && rootGroup.sub_groups) {
            return convertGroupsToTreeData(rootGroup.sub_groups);
        }
        return convertGroupsToTreeData(groups);
    }, [groups, convertGroupsToTreeData]);

    const handleGroupChange = (value: string) => {
        if (!value) {
            const unsortedGroup = allGroups.find((g) => g.name === 'Несортированные');
            setSelectedGroup(unsortedGroup || null);
            if (unsortedGroup) {
                formLeft.setFieldsValue({ groupName: unsortedGroup.name });
            }
        } else {
            const group = allGroups.find((g) => g.name === value);
            setSelectedGroup(group || null);
            if (group) {
                formLeft.setFieldsValue({ groupName: group.name });
            }
        }
    };

    const handleOwnerChange = (value: string) => {
        const owner = owners.find((o) => o.UID === value);
        setSelectedOwner(owner || null);
    };

    console.log(device);

    const initialValuesLeft = {
        name: device?.name,
        description: device?.description,
        groupName: device?.groupName,
    };

    const initialValuesRight = {
        ownerName: device?.ownerName,
        DID: device?.DID,
        model: device?.model,
    };

    useEffect(() => {
        if (device?.ownerUID && owners.length > 0) {
            const owner = owners.find((o) => o.UID === device.ownerUID);
            setSelectedOwner(owner || null);
        }
    }, [device, owners]);

    useEffect(() => {
        if (device?.groupUID && allGroups.length > 0) {
            const group = allGroups.find((g) => g.uid === device.groupUID);
            setSelectedGroup(group || null);
            if (group) {
                formLeft.setFieldsValue({ groupName: group.name });
            }
        }
    }, [device, allGroups, formLeft]);

    useEffect(() => {
        formLeft.setFieldsValue(initialValuesLeft);
        formRight.setFieldsValue(initialValuesRight);
    }, [device?.UID]);

    useEffect(() => {
        // Загружаем owners только при первом монтировании
        fetchOwners(page, pageSize);
        fetchGroups();
    }, []);

    const checkForChanges = () => {
        const valuesLeft = formLeft.getFieldsValue();
        const valuesRight = formRight.getFieldsValue();

        const changedValuesLeft = getChangedFields(initialValuesLeft, valuesLeft);
        const changedValuesRight = getChangedFields(initialValuesRight, valuesRight);

        setIsFormChanged(
            Object.keys(changedValuesLeft).length > 0 || Object.keys(changedValuesRight).length > 0,
        );
    };

    const handleDeviceDelete = () => {
        setIsDeleteDeviceOneModal(true);
    };

    const getChangedFields = (
        initialValues: { [key: string]: any },
        currentValues: { [key: string]: any },
    ) => {
        const changedFields: { [key: string]: any } = {};
        for (const key in currentValues) {
            if (currentValues[key] !== initialValues[key]) {
                changedFields[key] = currentValues[key];
            }
        }
        return changedFields;
    };

    const handleDeviceSave = async () => {
        if (user?.login) {
            try {
                const valuesLeft = await formLeft.validateFields();
                const valuesRight = await formRight.validateFields();

                const initialValuesLeft = {
                    name: device?.name,
                    description: device?.description,
                    groupUID: device?.groupUID,
                };
                const initialValuesRight = {
                    ownerName: device?.ownerName,
                    DID: device?.DID,
                    model: device?.model,
                };

                const changedValuesLeft = getChangedFields(initialValuesLeft, valuesLeft);
                const changedValuesRight = getChangedFields(initialValuesRight, valuesRight);
                console.log(selectedGroup);
                if (device?.UID && SmartDVRToken) {
                    const updatedDeviceData = {
                        UID: device.UID, // Здесь мы уже уверены, что UID не undefined
                        ...changedValuesLeft,
                        ...changedValuesRight,
                        groupName: selectedGroup ? selectedGroup.name : valuesLeft.groupUID,
                        ownerUID: selectedOwner ? selectedOwner.UID : valuesRight.ownerUID,
                        groupUID: selectedGroup ? selectedGroup.uid : valuesLeft.groupUID,
                    };

                    console.log(updatedDeviceData);

                    const response = await getEditDevice(
                        SmartDVRToken,
                        user.login,
                        updatedDeviceData,
                    );
                    console.log(response);
                    if (response?.success) {
                        formLeft.setFieldsValue({
                            ...formLeft.getFieldsValue(),
                            ...changedValuesLeft,
                            groupName: selectedGroup?.name || device?.groupName,
                        });

                        formRight.setFieldsValue({
                            ...formRight.getFieldsValue(),
                            ...changedValuesRight,
                            ownerName: selectedOwner?.name || device?.ownerName,
                        });

                        setSelectedDevice(response.data);

                        messageApi.success('Устройство обновлено');

                        setIsFormChanged(false);
                    } else {
                        const errorMessage = response?.error;

                        if (
                            errorMessage ===
                            'in DeviceUpdateByData user is not admin or wrong group'
                        ) {
                            messageApi.error(
                                'У пользователя нет прав на редактирование устройства',
                            );
                        } else {
                            messageApi.error('Ошибка обновления: ' + errorMessage);
                        }
                    }
                } else {
                    messageApi.error('Device UID or SmartDVRToken is missing');
                }
            } catch (error) {
                console.error('Validation failed:', error);
                messageApi.error('Validation failed');
            }
        } else {
            messageApi.error('User is not logged in');
        }
    };

    const handleOkDeleteDeviceOneModal = () => {
        setIsDeleteDeviceOneModal(false);
    };
    const handleCancelDeleteDeviceOneModal = () => {
        setIsDeleteDeviceOneModal(false);
    };

    const handleOkNotChangedDeiceModal = () => {
        handleDeviceSave();
        setIsNotSavedModalVisible(false);
    };
    const handleCancelNotChangedDeiceModal = () => {
        setIsNotSavedModalVisible(false);
    };

    console.log('owners', owners);
    return (
        <div className="description_cont">
            {contextHolder}
            <div className="desc">
                <div className="formGroupLeft">
                    {' '}
                    {/* Группа слева */}
                    <Form
                        form={formLeft}
                        className="form"
                        name="basicLeft"
                        labelCol={{ span: 5 }}
                        wrapperCol={{ span: 18 }}
                        onValuesChange={checkForChanges}
                    >
                        <Form.Item
                            label={<span className="inputLabel">Название</span>}
                            name="name"
                            rules={[
                                { required: true, message: 'Пожалуйста, введите название' }
                            ]}
                        >
                            <Input className="input" />
                        </Form.Item>

                        <Form.Item
                            label={<span className="inputLabel">Описание</span>}
                            name="description"
                        >
                            <Input className="input" />
                        </Form.Item>

                        <Form.Item
                            label={<span className="inputLabel">Группа</span>}
                            name="groupName"
                        >
                            <TreeSelect
                                placeholder="Введите название или выберите из списка"
                                onChange={handleGroupChange}
                                treeData={treeData}
                                showSearch
                                allowClear
                                treeDefaultExpandAll
                                filterTreeNode={(inputValue, treeNode) => {
                                    const title = String(treeNode.title || '');
                                    return title.toLowerCase().includes(inputValue.toLowerCase());
                                }}
                                treeNodeFilterProp="title"
                            />
                        </Form.Item>
                    </Form>
                </div>

                <div className="formGroupRight">
                    {/* Группа справа */}

                    <Form
                        form={formRight}
                        className="form"
                        name="basicRight"
                        labelCol={{ span: 5 }}
                        wrapperCol={{ span: 19 }}
                        onValuesChange={checkForChanges}
                    >
                        <Form.Item
                            label={<span className="inputLabel">Владелец</span>}
                            name="ownerName"
                        >
                            <Select
                                placeholder="Введите название или выберите из списка"
                                onChange={handleOwnerChange}
                            >
                                {owners?.map((owner) => (
                                    <Option key={owner?.UID} value={owner?.UID}>
                                        {owner?.name}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>

                        <Form.Item
                            label={<span className="inputLabel">Номер</span>}
                            name="DID"
                            rules={[
                                { required: true, message: 'Пожалуйста, введите номер' }
                            ]}
                        >
                            <Input className="input" disabled />
                        </Form.Item>

                        <Form.Item
                            label={<span className="inputLabel">Модель</span>}
                            name="model"
                        >
                            <Input className="input" />
                        </Form.Item>
                    </Form>
                </div>
            </div>
            <div className="description_footer">
                <div>
                    <ButtonDeviceSave onClick={handleDeviceSave} />
                    <ButtonDeviceAddToLayout onClick={handleDeviceAddToLayout} />
                    <ButtonDeviceDelete onClick={handleDeviceDelete} />
                </div>
            </div>

            <AddDeviceInLayoutModal
                visible={isAddToLayoutModalVisible}
                onOk={() => setIsAddToLayoutModalVisible(false)}
                onCancel={() => setIsAddToLayoutModalVisible(false)}
                setIsModalVisible={setIsAddToLayoutModalVisible}
                deviceToAdd={device}
            />

            <DeleteDeviceOneModal
                device={device}
                visible={isDeleteDeviceOneModal}
                onOk={handleOkDeleteDeviceOneModal}
                onCancel={handleCancelDeleteDeviceOneModal}
            />

            <NotSavedChanges
                device={device}
                onOk={handleOkNotChangedDeiceModal}
                onCancel={handleCancelNotChangedDeiceModal}
                visible={isNotSavedModalVisible}
            />
        </div>
    );
};

export default Description;
